<template>
	<Modal v-model="opened" wrapper-class="modal-centered" modal-class="modal-welcome" @closed="onClosed()" @before-open="bodyScrollPlugin.freeze()" @before-close="bodyScrollPlugin.unfreeze()">
		<template #titlebar>
			<div />
		</template>

		<div v-if="step==1">
			<div class="image">
				<img :src="'/customer/images/components/welcome-popup/step-1.png'" alt="">
			</div>
			<div class="text">
				<div>
					<h1>{{ t.welcomeStep1Title }}</h1>

					<p>{{ t.welcomeStep1Text }}</p>
				</div>
				<div class="button-row">
					<button type="button" class="btn-success" @click.stop="step++">
						{{ t.genericNext }}
					</button>
				</div>
			</div>
			<div class="clearfix" />
		</div>
		<div v-if="step==2">
			<div class="image">
				<img :src="'/customer/images/components/welcome-popup/step-2.png'" alt="">
			</div>
			<div class="text">
				<div>
					<h1>{{ t.welcomeStep2Title }}</h1>

					<p>{{ t.welcomeStep2Text }}</p>
				</div>
				<div class="button-row">
					<button type="button" class="btn-success" @click.stop="step++">
						{{ t.genericNext }}
					</button>
				</div>
			</div>
			<div class="clearfix" />
		</div>
		<div v-if="step==3">
			<div class="image">
				<img :src="'/customer/images/components/welcome-popup/step-3.png'" alt="">
			</div>
			<div class="text">
				<div>
					<h1>{{ t.welcomeStep3Title }}</h1>

					<p>{{ t.welcomeStep3Text }}</p>
				</div>
				<div class="button-row">
					<button type="button" class="btn-success" @click.stop="opened = false">
						{{ t.welcomePopupButtton }}
					</button>
				</div>
			</div>
			<div class="clearfix" />
		</div>
	</Modal>
</template>

<script setup>
import { computed, inject, onMounted, ref } from 'vue';
import { Modal } from '@kouts/vue-modal'
import bodyScrollPlugin from 'body-scroll-freezer'
import { preloadImages } from '@/js/includes/helpers';
import { useStore } from '@/js/stores/index';

const axios = inject('axios')
const store = useStore()

// Emits
const emit = defineEmits(['close'])

// Reactives
const opened = ref(false)
const html = ref('')
const step = ref(1)

// Computeds
const t = computed(() => store.translations)
const currentLanguage = computed(() => store.currentLanguage)

// Functions
function onClosed(){
	emit('close')
}

defineExpose({
	opened
})

// Mounted
onMounted(async () => {
	bodyScrollPlugin.init()

	preloadImages([
		"/customer/images/components/welcome-popup/step-1.png",
		"/customer/images/components/welcome-popup/step-2.png",
		"/customer/images/components/welcome-popup/step-3.png",
	])

	// Get welcome text
	const { data } = await axios.get('/api/user-side/getContent/welcome?lang=' + currentLanguage.value)
	html.value = data.text
})
</script>
<style scoped>
	h1{
		text-transform: uppercase;
	}
</style>